<template>
  <Radio
    class="c-bitts-radio"
    :data-testid="`bitts-radio-card-option-${option.value}`"
    :value="option.value"
    :disabled="option.disabled || disabled"
    :class="{
      last: index === options.length - 1,
      first: index === 0,
      only: options.length === 1,
    }"
  >
    <div class="flex-1">
      <div class="bitts-radio-group-cards__option-label">
        <slot name="label" :option="option">
          {{ option.label }}
        </slot>
      </div>
      <div
        v-if="option.description"
        class="bitts-radio-group-cards__description"
      >
        {{ option.description }}
      </div>
    </div>
    <slot name="right" />
  </Radio>
</template>

<script
  setup
  lang="ts"
  generic="TOption extends RadioOptionType = RadioOptionType"
>
import { Radio } from 'ant-design-vue';

import { RadioOptionType } from './types';

withDefaults(
  defineProps<{
    option: TOption;
    options?: TOption[];
    index?: number;
    disabled?: boolean;
  }>(),
  {
    options: () => [],
    index: 0,
    disabled: false,
  },
);

defineSlots<{
  label?: (props: { option: TOption }) => unknown;
  right?: () => unknown;
}>();
</script>

<style lang="pcss">
@reference "../../../../apps/crossbeam-app/src/css/theme.css";
.c-bitts-radio {
  @apply bg-white;
  .ant-radio {
    .ant-radio-inner {
      @apply border outline outline-neutral-border-strong border-transparent;
    }
  }

  &:hover:not(.ant-radio-wrapper-disabled) {
    .ant-radio-inner {
      @apply outline-secondary-background-medium outline-2 transition-none;
    }
  }

  .ant-radio-checked {
    .ant-radio-inner {
      border: none;
      @apply bg-white;
    }
    .ant-radio-inner::after {
      @apply bg-secondary-background-medium;
    }

    &:hover .ant-radio-inner {
      @apply outline-2;
    }
  }

  .ant-radio-input:focus-visible + .ant-radio-inner {
    box-shadow: none;
    @apply border-0 border-neutral-border-focus outline-neutral-border-focus outline-2;
  }

  .ant-radio-disabled:hover,
  .ant-radio-disabled {
    .ant-radio-inner {
      @apply bg-neutral-background-disabled border-0 outline-2 outline-neutral-background-disabled;
    }

    .ant-radio-inner::after {
      @apply bg-neutral-accent;
      @apply h-16! w-16! m-[-8px]!;
    }
  }
}
</style>
